export const navbarHeight = 16; // this is a global variable and it represents 14rems in tailwind
export const primaryColor = "rgb(17, 24, 39)"; // darker (navbar and sidebar color)
export const secondaryColor = "rgb(22,29,51)"; // lighter (background color)
export const tertiaryColor = "rgb(123,199,253)"; // lighter (sidebar hover color)
export const textColor = "rgb(146,147,152)"; // gray text color
export const userAvatarColor = "rgb(7,120,201)"; // blue user avatar 
export const forthColor = "rgb(31,41,55)"; // sidebar menu items color
